// Module
var code = "<a href=\"{{ model.homepageUrl }}\"> <img id=\"logo\" ng-src=\"{{ model.logoSrc }}\"> </a> ";
// Exports
module.exports = code;


//////////////////
// WEBPACK FOOTER
// ./public/hws/js/loginverification/views/banner.html
// module id = 244
// module chunks = 0